import './icons.css'

export const LetterIconSizes = {
    Small: 'small',
    Medium: 'medium',
    Large: 'large'
}
export const LetterIconTypes = {
    Primary: 'primary',
    Examiner: 'examiner',
    Trainee: 'trainee',
}

interface LetterIconProps {
    letter: string,
    size?: string,
    type?: string
}
export const LetterIcon = ({ letter, size = LetterIconSizes.Medium, type = LetterIconTypes.Primary }: LetterIconProps) => {
    return (
        <div className="letter-icon" style={getStyle()}>
            <div style={{
                color: `var(--letter-icon-color-${type.toLowerCase()})`
            }} className={`letter-icon-text letter-icon-text-${size.toLowerCase()}`}>{letter}</div>
        </div>
    )

    function getStyle() {
        let style: any = {
            width: 32,
            height: 32,
            borderWidth: 2
        }

        switch (size) {
            case LetterIconSizes.Small:
                style.width = 18;
                style.height = 18;
                style.borderWidth = 1;
                break;
            case LetterIconSizes.Medium:
                style.width = 26;
                style.height = 26;
                break;
            default:
                break;
        }
        return style
    }
}
